import React, { useEffect, useState } from 'react';
import { Card } from 'reactstrap';
import * as Icon from 'react-feather';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import { useDebouncedCallback } from 'use-debounce';

import AddEditBrandingModal from './AddEditBrandingModal';
import CallexLoader from '../../../components/CallexLoader';
import AdminHeader from '../../../components/header/AdminHeader';
import DeleteConfirmationModal from '../../../components/Modals/DeleteConfirmationModal';

import {
  brandingDelete,
  brandingListGet,
  useBrandingList
} from '../../../store/slices/adminSlices/brandingSlice';

const Branding = () => {
  const dispatch = useDispatch();
  const brandingList = useBrandingList();

  const [openAddModal, setOpenAddModal] = useState(false);
  const [editRecord, setEditRecord] = useState(null);
  const [isEdit, setIsEdit] = useState(null);
  const [isDeleteId, setIsDeleteId] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [filter, setFilter] = useState({
    page: 1,
    limit: 10,
    search: undefined
  });

  const fetchBrandingList = useDebouncedCallback(async () => {
    setIsLoading(true);
    try {
      const payload = { ...filter };
      await dispatch(brandingListGet(payload)).unwrap();
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.log('error', error);
    }
  }, 500);

  const deleteBranding = async () => {
    try {
      const response = await dispatch(brandingDelete(isDeleteId)).unwrap();
      if (response) {
        toast.success('Record deleted successfully');
        if (brandingList?.data?.length === 1) {
          setFilter({ ...filter, page: filter?.page > 1 ? filter.page - 1 : 1 });
        } else {
          fetchBrandingList();
        }
        setIsDeleteId(null);
      }
    } catch (error) {
      console.log('error', error);
    }
  };

  useEffect(() => {
    fetchBrandingList();
  }, [filter]);

  return (
    <div>
      <AdminHeader
        title="Branding"
        isExpandSearch
        isAdd
        onAddClick={() => setOpenAddModal(true)}
        addBtnName="Add Branding"
        searchPlaceholder="Search Branding"
        search={filter.search}
        handelSearch={(e) => setFilter({ ...filter, search: e.target.value })}
      />
      {isLoading ? (
        <Card
          className="p-0 d-flex justify-content-center align-items-center m-0"
          style={{ height: 'calc(100vh - 170px)' }}>
          <CallexLoader />
        </Card>
      ) : brandingList?.data?.length > 0 ? (
        <Card className="p-0 position-relative m-0">
          <div className="daily-report-table" style={{ height: 'calc(100vh - 170px)' }}>
            <table className="report-list-table">
              <thead>
                <tr>
                  <th>Header Text</th>
                  <th>Footer Text</th>
                  <th>Domain</th>
                  <th className="text-center" style={{ width: '90px' }}>
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody>
                {brandingList?.data?.map((val, index) => {
                  return (
                    <tr key={index}>
                      <td>{val?.header_text}</td>
                      <td>{val?.footer_text}</td>
                      <td>{val?.company_domain}</td>
                      <td>
                        <div className="d-flex justify-content-around align-items-center">
                          <div className="cursor-pointer text-info">
                            <Icon.Edit
                              size={16}
                              onClick={() => {
                                setEditRecord(val);
                                setIsEdit(true);
                                setOpenAddModal(true);
                              }}
                            />
                          </div>
                          <div className="cursor-pointer text-danger">
                            <Icon.Trash size={16} onClick={() => setIsDeleteId(val?.id)} />
                          </div>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </Card>
      ) : (
        <Card
          className="p-0 d-flex justify-content-center align-items-center no-data m-0"
          style={{ height: 'calc(100vh - 170px)' }}>
          No data available
        </Card>
      )}
      <DeleteConfirmationModal
        isOpen={!!isDeleteId}
        onCloseClick={() => setIsDeleteId(null)}
        onDeleteClick={() => deleteBranding()}
      />
      <AddEditBrandingModal
        isOpen={openAddModal}
        onCloseClick={(apiCall = false) => {
          setOpenAddModal(false);
          setEditRecord(null);
          setIsEdit(false);
          if (apiCall) {
            fetchBrandingList();
          }
        }}
        editRecord={editRecord}
        isEdit={isEdit}
      />
    </div>
  );
};

export default Branding;
